export default "__VITE_ASSET__455cd7f8__"